import { startOfDay, differenceInDays } from "date-fns";
import type { GetActiveLoansByMaturityQuery } from "~/types/graphql";

export const calculateLoanDefaults = (
  loans: GetActiveLoansByMaturityQuery["coolerLoans"],
  daysFromNow: number
): { count: number; value: number } => {
  const today = startOfDay(new Date());
  let defaultingCount = 0;
  let defaultingValue = 0;

  loans.forEach((loan) => { 
    
    const expiryDate = new Date(parseInt(loan.currentExpiryTimestamp) * 1000);
    const daysToExpiry = differenceInDays(expiryDate, today);


    // Check if loan will default within the specified days
    if (daysToExpiry >= 0 && daysToExpiry <= daysFromNow) {
      defaultingCount++;
      defaultingValue += parseFloat(loan.principal);
    }
  });

  return { count: defaultingCount, value: defaultingValue };
};

export function calculateDaysUntilDefault(expiryTimestamp: number): number {
  const now = Math.floor(Date.now() / 1000); // Current time in seconds
  const timeUntilDefault = expiryTimestamp - now;
  const daysUntilDefault = Math.floor(timeUntilDefault / (60 * 60 * 24));
  
  return Math.max(0, daysUntilDefault); // Return 0 if already defaulted
} 